import { formatDate } from "../../../../utils/configs/adminCardConfigs";

function TablaAdminLogsRow({ log }) {
  return (
    <tr>
      <td>{log.action_type}</td>
      <td>{log.decision || "-"}</td>
      <td>{log.actor_name || log.actor_email || "-"}</td>
      <td>{log.target_user_name || log.target_user_email || "-"}</td>
      <td>{log.comment || ""}</td>
      <td>{formatDate(log.created_at)}</td>
    </tr>
  );
}

export default TablaAdminLogsRow;
